import React from 'react';

import CarSVGIcon from '@Components/svg_icon/car';
import CartSVGIcon from '@Components/svg_icon/cart';
import HoleSVGIcon from '@Components/svg_icon/hole';
import InfoSVGIcon from '@Components/svg_icon/info';
import UpdateSVGIcon from '@Components/svg_icon/update';

import s from './style.module.css';

export type TabProps = {
    key: string;
    name: string;
    shortName: string;
    icon?: SVGKey;
    url?: string;
};

type TabTypes = {
    tabs: TabProps[];
    current: string;
    justifyContent?: string;
    innerWidth?: string;
    width?: string;
    onClick?: (t: string) => void;
    onClass?: string;
    offClass?: string;
    outerClass?: string;
    innerClass?: string;
    isSp: boolean;
};
const Tab: React.VFC<TabTypes> = (props: TabTypes) => {
    const w = props.width ? props.width : `${100 / props.tabs.length}%`;
    const innerWidth = props.innerWidth ?? '';
    const justifyContent = props.justifyContent ?? 'left';
    return (
        <div className={`${s.tabs_outer} ${props.outerClass}`}>
            <div
                className={`${s.tabs} ${props.innerClass}`}
                style={{
                    width: innerWidth,
                    justifyContent: justifyContent,
                }}
            >
                {props.tabs.map((t) =>
                    t.url ? (
                        <LinkTab
                            key={t.key}
                            {...t}
                            url={t.url}
                            width={w}
                            current={props.current}
                            tabkey={t.key}
                            isSp={props.isSp}
                            shortName={t.shortName}
                        />
                    ) : (
                        <DivTab
                            key={t.key}
                            {...t}
                            {...props}
                            width={w}
                            tabkey={t.key}
                            isSp={props.isSp}
                            shortName={t.shortName}
                        />
                    )
                )}
            </div>
        </div>
    );
};

type DivTabProps = {
    width: string;
    tabkey: string;
    name: string;
    shortName: string;
    current: string;
    icon?: SVGKey;
    onClick?: (t: string) => void;
    onClass?: string;
    offClass?: string;
    isSp: boolean;
};

type SVGKey = 'hole' | 'car' | 'cart' | 'update' | 'info';

const DivTab = (props: DivTabProps) => {
    const onClass = props.onClass ?? s.on;
    const offClass = props.offClass ?? s.tab;
    const isCurrent = props.tabkey === props.current;
    const name = props.isSp ? props.shortName : props.name;
    return (
        <div
            style={{
                width: `${props.width}`,
            }}
            onClick={() => props.onClick(props.tabkey)}
            className={`${offClass} ${isCurrent ? onClass : ''}`}
        >
            {props.icon ? <SVGIcon front_fill={isCurrent ? '#31599a' : '#789dd8'} iconKey={props.icon} /> : ''}
            {name}
        </div>
    );
};

type LinkTabProps = {
    width: string;
    url: string;
    tabkey: string;
    name: string;
    shortName: string;
    current: string;
    isSp: boolean;
};
const LinkTab = (props: LinkTabProps) => {
    const name = props.isSp ? props.shortName : props.name;
    return (
        <a
            style={{
                width: `${props.width}`,
            }}
            href={props.url}
            className={`${s.tab} ${props.tabkey === props.current ? s.on : ''}`}
        >
            {name}
        </a>
    );
};

type SVGIconProps = {
    iconKey: SVGKey;
    className?: string;
    bg_fill?: string;
    front_fill?: string;
};
const SVGIcon = (props: SVGIconProps) => {
    switch (props.iconKey) {
        case 'hole':
            return <HoleSVGIcon {...props} />;
        case 'car':
            return <CarSVGIcon {...props} />;
        case 'cart':
            return <CartSVGIcon {...props} />;
        case 'update':
            return <UpdateSVGIcon {...props} />;
        case 'info':
            return <InfoSVGIcon {...props} />;
    }
};

export default Tab;
